'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Rating = require('./components/Rating.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rating).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/rating/lib/index.js
// module id = 141
// module chunks = 1